import { ADDBASE, REMOVEBASE } from '../mutation-types.js';
let state = {
    upimgbase: [],
    showimg: [],
    count:1000,
}

let mutations={
    [ADDBASE](state,obj){
        if (obj.upimg !== undefined) {
            state.upimgbase.push(obj.upimg);
        }
        if (obj.showimg !== undefined) {
            state.showimg.push(obj.showimg);
        }
    },
    [REMOVEBASE](state,obj){
        if(typeof obj.num === 'number'){
            state.upimgbase.splice(obj.num,1);
            state.showimg.splice(obj.num,1);
        }
        console.log(state)
    }
}
let actions ={
    addbase({commit},obj){
        commit('ADDBASE',obj)
    },
    removebase({commit},obj){
        commit('REMOVEBASE',obj)
    }
}
export default({
    //namespaced: true, //命名空间开启
    state,
    actions,
    mutations
})